module.exports = __webpack_public_path__ + "img/bs.66058b81.png";